import { Component } from 'react';
import Directories from './Directories';
import { TAGS } from './keys';
import SearchDistance from './StrikingDistance';
import KeywordClusters from './KeywordClusters';
import YearKeywords from './YearKeywords';
import moment from 'moment';
import Evergreen from './Evergreen';
import { withTranslation } from 'react-i18next';

class GSCReportComparisonItems extends Component {
    constructor(props) {
        super();
        this.onChangeTags = this.onChangeTags.bind(this);
        this.showElement = this.showElement.bind(this);
        this.addActive = this.addActive.bind(this);
        this.updateDatas = this.updateDatas.bind(this);

        this.url = new URL(window.location);
        let view = this.url.searchParams.get('view');

        if (view === 'all') {
            view = TAGS(props.t).map((tag) => tag.id);
        } else {
            view = [view];
        }

        this.state = {
            types: view,
            datas: {},
        };
    }

    onChangeTags(id) {
        this.url.searchParams.set('view', id);
        history.pushState({}, '', this.url);

        if (id === 'all') {
            return this.setState({
                types: TAGS(this.props.t).map((tag) => tag.id),
            });
        }

        this.setState({
            types: [id],
        });
    }

    showElement(id) {
        return !this.state.types.length || this.state.types.includes(id);
    }

    addActive(id) {
        if (this.state.types.includes('all')) {
            if (id === 'all') return true;
            return false;
        }

        return this.state.types.includes(id);
    }

    updateDatas({ key, value, emptyAll = false }) {
        if (emptyAll) {
            return this.setState({
                datas: {},
            });
        }

        this.setState({
            datas: {
                ...this.state.datas,
                [key]: value,
            },
        });
    }

    render() {
        const { t } = this.props;
        const tags = TAGS(t);
        const currentYear = moment().year();
        const lastYear = moment().subtract(1, 'years').year();
        return (
            <>
                <div className="tags-container">
                    {tags?.map((tag) => (
                        <span
                            className={`tab-item ${this.addActive(tag.id) && 'active-tag'}`}
                            key={tag.id}
                            onClick={() => this.onChangeTags(tag.id)}
                        >
                            {t(`opportunities.tabs.${tag.id}`, { defaultValue: tag.label })}
                        </span>
                    ))}
                </div>
                {this.showElement(tags[0].id) && (
                    <div id="overall-table-content">
                        <div className="row card-row" id="overall-table">
                            <div className="col-12">
                                <div className="card table-main rounded-main overflow-hidden">
                                    <SearchDistance
                                        data={this.state.datas.strikingDistance}
                                        updateDatas={this.updateDatas}
                                        message={this.props.message}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {this.showElement(tags[1].id) && (
                    <div id="keywordClusters-content">
                        <div className="row card-row" id="keywordClusters-page">
                            <div className="col-12">
                                <div className="card table-main rounded-main overflow-hidden">
                                    <KeywordClusters
                                        data={this.state.datas.keywordClusters}
                                        updateDatas={this.updateDatas}
                                        message={this.props.message}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {this.showElement(tags[2].id) && (
                    <div id="directories-content">
                        <div className="row card-row" id="directories-page">
                            <div className="col-12">
                                <div className="card table-main rounded-main overflow-hidden">
                                    <Directories
                                        data={this.state.datas.directories}
                                        updateDatas={this.updateDatas}
                                        message={this.props.message}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {this.showElement(tags[3].id) && (
                    <div id="directories-content">
                        <div className="row card-row" id="directories-page">
                            <div className="col-12">
                                <div className="card table-main rounded-main overflow-hidden">
                                    <Evergreen
                                        data={this.state.datas.evergreen}
                                        updateDatas={this.updateDatas}
                                        ignored_urls={this.props.ignored_urls}
                                        csrf_token={this.props.csrf_token}
                                        message={this.props.message}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {this.showElement(tags[4].id) && (
                    <div id="directories-content">
                        <div className="row card-row" id="directories-page">
                            <div className="col-12">
                                <div className="card table-main rounded-main overflow-hidden">
                                    <YearKeywords
                                        data={this.state.datas.yearKeywords}
                                        updateDatas={this.updateDatas}
                                        message={this.props.message}
                                        lastYear={lastYear}
                                        currentYear={currentYear}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    }
}

export default withTranslation()(GSCReportComparisonItems);
